import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import { useState } from "react";
import CustomTable from "components/CustomTable";

const TeacherDetail = () => {
  const [activeTab, setActiveTab] = useState("attendance");

  return (
    <>
      <div
        className="header   d-flex align-items-center"
        style={{
          minHeight: "600px",
          backgroundImage:
            "url(" + require("../../assets/img/theme/alRehman.jpg") + ")",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      >
        {/* Mask */}
        <span className="mask bg-gradient-default opacity-8" />
        {/* Header container */}
        <Container className="d-flex align-items-center" fluid>
          <Row>
            <Col lg="7" md="10">
              <h1 className="display-2 text-white">Staff Management</h1>
              <p className="text-white mt-0 mb-5">
                Here you can view and manage the details of the students in your
                care. Review the information carefully and make any necessary
                updates or follow-ups.
              </p>
              <Button
                size="sm"
                color={activeTab === "attendance" ? "danger" : "secondary"}
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("attendance");
                }}
              >
                Attendance Tracking
              </Button>
              <Button
                size="sm"
                color={activeTab === "leave" ? "warning" : "secondary"}
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("leave");
                }}
              >
                Leave Management
              </Button>
              <Button
                size="sm"
                color={activeTab === "payroll" ? "info" : "secondary"}
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("payroll");
                }}
              >
                Payroll Management
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {activeTab === "attendance" && <AttendanceTracking />}
        {activeTab === "leave" && <LeaveManagement />}
        {activeTab === "payroll" && <PayrollManagement />}
      </Container>
    </>
  );
};
export default TeacherDetail;
const AttendanceTracking = () => {
  const columns = ["Date", "Attendance Type", "Hours Worked", "Overtime Hours"];
  const rows = [
    {
      date: "2024-08-20",
      attendanceType: "Full Day",
      hoursWorked: "8 hours",
      overtimeHours: "2 hours",
    },
    {
      date: "2024-08-21",
      attendanceType: "Half Day",
      hoursWorked: "4 hours",
      overtimeHours: "0 hours",
    },
    {
      date: "2024-08-22",
      attendanceType: "Overtime",
      hoursWorked: "10 hours",
      overtimeHours: "4 hours",
    },
  ];

  return (
    <Card>
      <CardHeader>
        <h3 className="mb-0">Attendance Tracking</h3>
      </CardHeader>
      <CardBody>
        <CustomTable columns={columns} rows={rows} />
      </CardBody>
    </Card>
  );
};

const LeaveManagement = () => {
  const columns = [
    "Leave Type",
    "Leave Date",
    "Leave Balance",
    "Medical Certificate",
  ];
  const rows = [
    {
      leaveType: "Sick Leave",
      leaveDate: "2024-08-20",
      leaveBalance: "5 days",
      medicalCertificate: "Yes",
    },
    {
      leaveType: "Annual Leave",
      leaveDate: "2024-08-25",
      leaveBalance: "10 days",
      medicalCertificate: "No",
    },
    {
      leaveType: "Maternity Leave",
      leaveDate: "2024-09-01",
      leaveBalance: "30 days",
      medicalCertificate: "Yes",
    },
  ];

  return (
    <Card>
      <CardHeader>
        <h3 className="mb-0">Leave Management</h3>
      </CardHeader>
      <CardBody>
        <CustomTable columns={columns} rows={rows} />
      </CardBody>
    </Card>
  );
};

const PayrollManagement = () => {
  const columns = ["Payroll Period", "Salary", "Overtime Pay", "Bonus"];
  const rows = [
    {
      payrollPeriod: "August 2024",
      salary: "$5000",
      overtimePay: "$1000",
      bonus: "$500",
    },
    {
      payrollPeriod: "September 2024",
      salary: "$5500",
      overtimePay: "$1200",
      bonus: "$600",
    },
    {
      payrollPeriod: "October 2024",
      salary: "$6000",
      overtimePay: "$1500",
      bonus: "$700",
    },
  ];

  return (
    <Card>
      <CardHeader>
        <h3 className="mb-0">Payroll Management</h3>
      </CardHeader>
      <CardBody>
        <CustomTable columns={columns} rows={rows} />
      </CardBody>
    </Card>
  );
};
